// Sidebar entries owned by the Tenders module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { tendersPaths } from './paths'

// The sidebar fields Tenders' entry uses. Structurally the app's SidebarType
// (src/types/shared): src/app/nav.tsx places these entries, so a drift between
// the two fails typecheck there.
interface TendersNavItem {
    title: string
    path: string
}

export const tendersNav = {
    list: {
        title: 'tenders:sidebar_title',
        path: tendersPaths.tenders,
    },
} satisfies Record<string, TendersNavItem>
